const buildQuery = (query) => {
  if (typeof query === 'string') {
    return query
  }
  let result = []
  for (const key in query) {
    let itemVal = ''
    const item = query[key]
    if (item === false) continue
    if (typeof item === 'string') {
      result.push(item)
      continue
    }
    if (typeof key === 'string') {
      itemVal += key
    }
    if (item.from) {
      itemVal += `:${item.from}`
    }
    if (item.where) {
      let where = []
      for (const param in item.where) {
        where.push(`${param}:${item.where[param]}`)
      }
      itemVal += `(${where.join(' ')})`
    }
    if (item.select) {
      itemVal += buildQuery(item.select)
    } else if (typeof item !== 'string' && !item.select && !item.where && !item.from) {
      itemVal += buildQuery(item)
    }
    result.push(itemVal)
  }
  if (result.length === 0) {
    return ''
  }
  return `{${result.join(' ')}}`
}

export default {
  buildQuery
}



// WEBPACK FOOTER //
// ./src/services/queryBuilder.js